import { Column } from "@faire/web/slate/Layout";
import React from "react";

import { SDUIComponentInstanceRendererProps } from "@faire/retailer/components/SDUI/__internal__/types";
import { SDUICarousel } from "@faire/retailer/components/SDUI/ComponentRenderers/Carousel/__internal__/SDUICarousel";
import { SDUICarouselHeaderRow } from "@faire/retailer/components/SDUI/ComponentRenderers/Carousel/__internal__/SDUICarouselHeaderRow";
import * as carouselStyles from "@faire/retailer/components/SDUI/ComponentRenderers/Carousel/__internal__/styles.css";

export const SDUICarouselRenderer: React.FC<
  SDUIComponentInstanceRendererProps
> = ({ component, loggingData, renderBehaviour }) => {
  const carouselElement = component.carousel_component;
  if (!carouselElement) {
    return null;
  }

  const { title, cta_button, sub_title, tiles, tagline, style } =
    carouselElement;
  if (tiles === undefined || tiles.length === 0) {
    return null;
  }

  return (
    <Column
      className={carouselStyles.SDUICarouselWrapper}
      data-test-id="carousel-renderer"
    >
      <SDUICarouselHeaderRow
        title={title}
        cta_button={cta_button}
        sub_title={sub_title}
        tagline={tagline}
        loggingData={loggingData}
      />
      <SDUICarousel
        style={style}
        tiles={tiles}
        loggingData={loggingData}
        renderBehaviour={renderBehaviour}
      />
    </Column>
  );
};
